import React from 'react';
import TeachersDatClass6to12  from 'views/TeachersDatClass6to12';


const SchoolProgrampage = () => {
  return <TeachersDatClass6to12/>;
};

export default SchoolProgrampage;